import { render } from "./ContractVehicles.vue?vue&type=template&id=223aab56&scoped=true&ts=true"
import script from "./ContractVehicles.vue?vue&type=script&lang=ts"
export * from "./ContractVehicles.vue?vue&type=script&lang=ts"

import "./ContractVehicles.vue?vue&type=style&index=0&id=223aab56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223aab56"]])

export default __exports__